const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Zulassungsschein',
	'vehicleRegistrationDocument.description':
		'Laden Sie deutliche Fotos der angeforderten Seiten des Zulassungsscheins hoch.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Vorderseite des Zulassungsscheins',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Fotografieren Sie die Vorderseite des Zulassungsscheins deutlich.',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'Vorderseite des Zulassungsscheins',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Vorderseite des Zulassungsscheins - Beispiel',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Vorderseite des Zulassungsscheins',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title': 'Rückseite des Zulassungsscheins',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Fotografieren Sie die Rückseite des Zulassungsscheins deutlich.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Rückseite des Zulassungsscheins',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Rückseite des Zulassungsscheins - Beispiel',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Rückseite des Zulassungsscheins',
	'vehicleRegistrationDocument.validationHeadline': 'Fehlende Fotos',
	'vehicleRegistrationDocument.validationDescription': 'Bitte fügen Sie die folgenden Fotos hinzu:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Zulassungsschein fotografieren',
	'review.stepDescription.vehicleRegistrationDocument': 'Zulassungsschein',
	'loader.loading': 'Daten werden geladen …',
	'loader.error': 'Ihr Vorgang konnte nicht geladen werden. Bitte versuchen Sie es später erneut …',
	'connectionError.title': 'Verbindungsfehler',
	'connectionError.description': 'Verbindungsfehler. Bitte laden Sie das Foto erneut hoch.',
	'mainError.tryAgain': 'Erneut versuchen',
	'landing.headline.policyCheck': 'Willkommen',
	'landing.paragraph':
		'Sie sind nur noch zwei Schritte davon entfernt, die digitale Vorschadenbesichtigung abzuschließen.',
	'landing.stepDescription.fourAdditionalPictures': 'Machen Sie die erforderlichen Fotos',
	'landing.stepDescription.fourDiagonalPerspectives': 'Machen Sie die erforderlichen Fotos',
	'landing.stepDescription.feedback': 'Lassen Sie uns wissen, wie es gelaufen ist',
	'landing.termsAndConditionsLinkDescription':
		'Mit dem Drücken auf „Start“ akzeptieren Sie unsere <tclink>Allgemeinen Geschäftsbedingungen</tclink>.',
	'landing.termsAndConditionsLink':
		'Mit dem Drücken auf „Start“ akzeptieren Sie unsere Allgemeinen Geschäftsbedingungen.',
	'button.start': 'Start',
	'landing.aboutPolicyCheck': 'Zurück',
	'landing.additional-informations-section.title':
		'Für eine erfolgreiche Vorschadenbesichtigung stellen Sie bitte sicher, dass …',
	'landing.additional-informations-section.text':
		'<ul><li>Ihr Fahrzeug sauber und trocken ist.</li><li>Sie die Begutachtung bei Tageslicht bzw. in sehr gut beleuchteten Garagen durchführen.</li><li>das gesamte Fahrzeug auf den Fotos gut erkennbar ist (idealerweise Querformat).</li></ul>',
	'landing.additional-informations-section.text.motorbike': ' ',
	'chooseLang.headline': 'Wählen Sie Ihre bevorzugte Sprache',
	'button.close': 'Schließen',
	'blockedByDevice.headline': 'PolicyCheck unterstützt keine Desktop-Browser',
	'blockedByDevice.description':
		'PolicyCheck wird mit einem Desktop-Browser verwendet.<br>Die PolicyCheck-Plattform dokumentiert Fälle mit mobilen Geräten.<br>Um fortzufahren, öffnen Sie den PolicyCheck-Link bitte auf einem mobilen Gerät.',

	'vehicleImages.overviewPhotos': 'Fahrzeug Übersicht',
	'vehicleImages.overviewPhotos.subtitle': ' ',
	'vehicleImages.description':
		'Fotografieren Sie das gesamte Fahrzeug aus allen Blickwinkeln (idealerweise Querformat). Das Kennzeichen sollte auf allen Fotos gut sichtbar sein. Bitte orientieren Sie sich an den Beispiel Fotos.',
	'vehicleImages.description.motorbike': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Vorne links diagonal',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Hinten links diagonal',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Hinten rechts diagonal',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Vorne rechts diagonal',
	'button.next': 'Weiter',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Foto-Beispiel',
	'imageRecognitionMismatchModal.headline':
		'Das aufgenommene Foto entspricht <b>nicht</b> den notwendigen <b>Anforderungen</b>, bitte versuchen Sie es erneut. Wenn Sie mit diesem Foto fortsetzten, können wir keine vollständige Vorschadenbesichtigung garantieren und Sie erhalten in den nächsten Tagen Ihre Versicherungsurkunde mit dem vereinbarten <b>erhöhten</b> Selbstbehalt <b>(1.200€)</b>.',
	'button.continue': 'WEITER',
	'button.backchangeImage': 'FOTO ERNEUT AUFNEHMEN',
	'completeVehicleImagesModal.headline': 'Fehlende Fotos',
	'completeVehicleImagesModal.description': 'Bitte fügen Sie die folgenden Fotos hinzu:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Vorne links diagonal',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Hinten links diagonal',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Vorne rechts diagonal',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Hinten rechts diagonal',
	'vehicleImages.leftFrontOverview': 'Vorne links diagonal',
	'vehicleImages.leftRearOverview': 'Hinten links diagonal',
	'vehicleImages.rightRearOverview': 'Hinten rechts diagonal',
	'vehicleImages.rightFrontOverview': 'Vorne rechts diagonal',
	'button.changeImage': 'FOTO ERNEUT AUFNEHMEN',
	'button.deleteImage': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Vorne links diagonal Beispielfoto',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'Hinten links diagonal Beispielfoto',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Hinten rechts diagonal Beispielfoto',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Vorne rechts diagonal Beispielfoto',
	'button.ok': 'OK',
	'fourPerspectivesExampleModal.button.close': 'OK',
	'button.prev': 'Zurück',

	'fourAdditionalPictures.title': 'Zusätzliche Informationen',
	'fourAdditionalPictures.overallDashboard.title': 'Armaturenbrett',
	'fourAdditionalPictures.overallDashboard.description':
		'Machen Sie ein Foto, welches das komplette Armaturenbrett des Fahrzeugs zeigt. Am besten gelingt die Aufnahme im Querformat von der Rückbank.',
	'fourAdditionalPictures.mileage.title': 'Kilometerstand',
	'dashboardMileage.dashboard.paragraph':
		'Machen Sie ein Foto des Fahrzeugtachos mit gut sichtbarem aktuellem Kilometerstand. Wenn Sie ein digitales Display haben, schalten Sie es bitte ein.',
	'dashboardMileage.paragraph.first': 'Geben Sie den aktuellen Kilometerstand ein.',
	'dashboardMileage.placeholder': 'Aktueller Kilometerstand',
	'dashboardMileage.input.error': 'Bitte geben Sie den aktuellen Kilometerstand des Fahrzeugs ein.',
	'feedback.comment.placeholder': 'Kommentar hinzufügen',
	'fourAdditionalPictures.windshield.title': 'Windschutzscheibe',
	'fourAdditionalPictures.windshield.description':
		'Machen Sie ein detailliertes Foto der gesamten Windschutzscheibe des Fahrzeugs.',
	'fourAdditionalPictures.vin.title': 'Fahrgestellnummer (FIN)',
	'fourAdditionalPictures.vin.description':
		'Machen Sie ein Foto der Fahrgestellnummer (FIN) des Fahrzeugs. Diese ist eine 17-stellige Kombination aus Zahlen & Buchstaben. Die FIN kann sich am Türrahmen, in der unteren rechten Ecke der Windschutzscheibe oder auch im Motorraum befinden. Nähere Details zur Position der FIN bei Ihrem Fahrzeug finden Sie in Ihrer Betriebsanleitung.',
	'overallDashboardImage.title': 'Armaturenbrett',
	'dashboardMileage.dashboard.title': 'Kilometerstand',
	'windshieldImage.title': 'Windschutzscheibe',
	'vinPicture.title': 'Fahrgestellnummer (FIN)',
	'completeFourAdditionalPicturesModal.headline': 'Fehlende Fotos',
	'completeFourAdditionalPicturesModal.description': 'Bitte fügen Sie die folgenden Fotos hinzu:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Armaturenbrett',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Kilometerstand',
	'completeDashboardMileageModal.hasValidMileage': 'Kilometerstand',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Fahrgestellnummer (FIN)',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Windschutzscheibe',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Armaturenbrett Foto-Beispiel',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Kilometerstand Foto-Beispiel',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Windschutzscheibe Foto-Beispiel',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Fahrgestellnummer (FIN) Foto-Beispiel',
	'fourAdditionalPicturesExampleModal.button.close': 'OK',
	'fourPicturesExampleModal.button.close': 'OK',

	'fourAdditionalDocuments.title': ' ',
	'fourAdditionalDocuments.RegistrationDocument.title': ' ',
	'fourAdditionalDocuments.RegistrationDocument.description': ' ',
	'image.locked.RegistrationDocument': ' ',
	'fourAdditionalDocuments.RegistrationDocumentInside.title': ' ',
	'fourAdditionalDocuments.RegistrationDocumentInside.description': ' ',
	'image.locked.RegistrationDocumentInside': ' ',
	'fourAdditionalDocuments.DniInside.title': ' ',
	'fourAdditionalDocuments.DniInside.description': ' ',
	'image.locked.DniInside': ' ',
	'fourAdditionalDocuments.DniOutside.title': ' ',
	'fourAdditionalDocuments.DniOutside.description': ' ',
	'image.locked.DniOutside': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.title': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.description': ' ',
	'image.locked.VehicleDatasheetInside': ' ',
	'fourAdditionalDocuments.VehicleDatasheetInside.title': ' ',
	'fourAdditionalDocuments.VehicleDatasheetInside.description': ' ',
	'image.locked.VehicleDatasheetOutside': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.title': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.description': ' ',
	'image.locked.DriverLicenseInside': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.title': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.description': ' ',
	'image.locked.DriverLicenseOutside': ' ',
	'completeFourAdditionalDocumentsModal.headline': ' ',
	'completeFourAdditionalDocumentsModal.description': ' ',
	'fourAdditionalDocuments.RegistrationDocument.headline': ' ',
	'fourAdditionalDocuments.RegistrationDocumentInside.headline': ' ',
	'fourAdditionalDocuments.DniInside.headline': ' ',
	'fourAdditionalDocuments.DniOutside.headline': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.headline': ' ',
	'fourAdditionalDocuments.VehicleDatasheetInside.headline': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.headline': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.headline': ' ',
	'fourAdditionalDocuments.RegistrationDocument.exampleModalTitle': ' ',
	'fourAdditionalDocuments.RegistrationDocumentInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DniInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DniOutside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.VehicleDatasheetInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.exampleModalTitle': ' ',
	'vinPicture.headline': 'Fahrgestellnummer (FIN)',
	'windshieldImage.headline': 'Windschutzscheibe',
	'overallDashboardImage.headline': 'Armaturenbrett',

	'feedback.headline.policyCheck': 'Alle Bilder wurden erfolgreich empfangen!',
	'feedback.description': ' ',
	'feedback.rating.policyCheck': 'Wie würden Sie Ihre Erfahrung bewerten?',
	'feedback.yourOpinion': 'Haben Sie Kommentare? Lassen Sie es uns wissen!',
	'feedback.button.send': 'Absenden',
	'waitForAudit.thankYou': 'Vielen Dank für Ihr Feedback!',
	'waitForAudit.description.damageFound': ' ',
	'thanks.headline.first': 'Vielen Dank für Ihr Feedback!',
	'thanks.paragraph.first': ' ',

	'timeout.headline.first': 'el enlace a la aplicación ya no está disponible.',
	'timeout.paragraph.first': ' ',
	'timeout.bottom': ' ',

	'mismatchModal.enteredMileage': 'eingegebener Kilometerstand',

	'invalidFile.size.title': 'Falsche Bildgröße',
	'invalidFile.size.description': 'Die Bildgröße ist größer als die maximal erforderliche Größe.',
	'invalidFile.extension.title': 'Dateityp wird nicht unterstützt',
	'invalidFile.extension.description':
		'Der angegebene Dateityp wird nicht unterstützt. Unterstützte Dateitypen: .jpg, .jpeg, .jfif, .png, .bmp, .heic und .heif.',
	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',
};

export default messages;
